import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_11a85795 from 'nuxt_plugin_head_11a85795' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_261b8e9f from 'nuxt_plugin_plugin0_261b8e9f' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_261c02fe from 'nuxt_plugin_plugin1_261c02fe' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_261c775d from 'nuxt_plugin_plugin2_261c775d' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_261cebbc from 'nuxt_plugin_plugin3_261cebbc' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_261d601b from 'nuxt_plugin_plugin4_261d601b' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_261dd47a from 'nuxt_plugin_plugin5_261dd47a' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_261e48d9 from 'nuxt_plugin_plugin6_261e48d9' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_261ebd38 from 'nuxt_plugin_plugin7_261ebd38' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_261f3197 from 'nuxt_plugin_plugin8_261f3197' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_261fa5f6 from 'nuxt_plugin_plugin9_261fa5f6' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_c53738c0 from 'nuxt_plugin_plugin10_c53738c0' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_c5365002 from 'nuxt_plugin_plugin11_c5365002' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_c5356744 from 'nuxt_plugin_plugin12_c5356744' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_c5347e86 from 'nuxt_plugin_plugin13_c5347e86' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_c53395c8 from 'nuxt_plugin_plugin14_c53395c8' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_c532ad0a from 'nuxt_plugin_plugin15_c532ad0a' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_c531c44c from 'nuxt_plugin_plugin16_c531c44c' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_c530db8e from 'nuxt_plugin_plugin17_c530db8e' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_c52ff2d0 from 'nuxt_plugin_plugin18_c52ff2d0' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_c52f0a12 from 'nuxt_plugin_plugin19_c52f0a12' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_c51b09be from 'nuxt_plugin_plugin20_c51b09be' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_c51a2100 from 'nuxt_plugin_plugin21_c51a2100' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_c5193842 from 'nuxt_plugin_plugin22_c5193842' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_c5184f84 from 'nuxt_plugin_plugin23_c5184f84' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_c51766c6 from 'nuxt_plugin_plugin24_c51766c6' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_11a85795 === 'function') {
    await nuxt_plugin_head_11a85795(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_261b8e9f === 'function') {
    await nuxt_plugin_plugin0_261b8e9f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_261c02fe === 'function') {
    await nuxt_plugin_plugin1_261c02fe(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_261c775d === 'function') {
    await nuxt_plugin_plugin2_261c775d(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_261cebbc === 'function') {
    await nuxt_plugin_plugin3_261cebbc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_261d601b === 'function') {
    await nuxt_plugin_plugin4_261d601b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_261dd47a === 'function') {
    await nuxt_plugin_plugin5_261dd47a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_261e48d9 === 'function') {
    await nuxt_plugin_plugin6_261e48d9(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_261ebd38 === 'function') {
    await nuxt_plugin_plugin7_261ebd38(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_261f3197 === 'function') {
    await nuxt_plugin_plugin8_261f3197(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_261fa5f6 === 'function') {
    await nuxt_plugin_plugin9_261fa5f6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_c53738c0 === 'function') {
    await nuxt_plugin_plugin10_c53738c0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_c5365002 === 'function') {
    await nuxt_plugin_plugin11_c5365002(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_c5356744 === 'function') {
    await nuxt_plugin_plugin12_c5356744(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_c5347e86 === 'function') {
    await nuxt_plugin_plugin13_c5347e86(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_c53395c8 === 'function') {
    await nuxt_plugin_plugin14_c53395c8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_c532ad0a === 'function') {
    await nuxt_plugin_plugin15_c532ad0a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_c531c44c === 'function') {
    await nuxt_plugin_plugin16_c531c44c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_c530db8e === 'function') {
    await nuxt_plugin_plugin17_c530db8e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_c52ff2d0 === 'function') {
    await nuxt_plugin_plugin18_c52ff2d0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_c52f0a12 === 'function') {
    await nuxt_plugin_plugin19_c52f0a12(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_c51b09be === 'function') {
    await nuxt_plugin_plugin20_c51b09be(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_c51a2100 === 'function') {
    await nuxt_plugin_plugin21_c51a2100(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_c5193842 === 'function') {
    await nuxt_plugin_plugin22_c5193842(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_c5184f84 === 'function') {
    await nuxt_plugin_plugin23_c5184f84(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_c51766c6 === 'function') {
    await nuxt_plugin_plugin24_c51766c6(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
